var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-10 mb-1",staticStyle:{"max-width":"200px"},attrs:{"outlined":""},on:{"click":_vm.clicked}},[(!_vm.imageURL)?_c('div',{staticClass:"text-center my-5"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_vm._e(),(_vm.imageURL)?_c('v-img',{attrs:{"src":_vm.imageURL}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }